import $ from 'jquery';

export default class TemplatePassword {
  constructor(template) {
    this.el = template.el;
    this.$el = $(this.el);

    this.adminLogin = $('.password-page-modal-wrapper', this.el);
    this.adminModal = this.adminLogin.find('.password-page-modal');
    this.openByDefault = this.adminLogin.find('[data-open-modal]').length;

    if (this.openByDefault) {
      this.open();
    }

    $('.close', this.el).on('click.password', this.close.bind(this));
    $('.close-modal', this.el).on('click.password', this.close.bind(this));
    $('.admin-login-modal', this.el).on('click.password', this.open.bind(this));
    $(window).on('resize.password', () => this.formatTheModal());
  }

  formatTheModal() {
    if ($(window).height() <= this.adminModal.outerHeight()) {
      this.adminModal.css({ 'margin-top': 0 });
    } else {
      const offset = ($(window).height() - this.adminModal.outerHeight()) / 2;
      this.adminModal.css({ 'margin-top': offset });
    }
  }

  open() {
    $('body').css({ overflow: 'hidden' }); // Locks the background
    this.adminLogin.show(); // Display modal background
    this.formatTheModal(); // Vertically / horizontally center and resize the modal
    this.adminLogin.fadeTo(200, 1);

    // Bind the close function to the 'esc' key
    $(document).on('keyup.password', (e) => {
      if (e.keyCode === 27) {
        this.close();
      }
    });
  }

  close(e) {
    if ((e == null) || (e.target === e.currentTarget)) {
      this.adminLogin.fadeTo(200, 0, () => {
        this.adminLogin.hide();
      });

      $(document).off('keyup.password');
    }
  }

  unload() {
    $('.close', this.el).off('click.password');
    $('.close-modal', this.el).off('click.password');
    $('.admin-login-modal', this.el).off('click.password');
    $(window).off('resize.password');
    $(document).off('keyup.password');
  }
}
